<div
  [ngStyle]="{ 'background-image': 'url(' + image + ')' }"
  [ngClass]="{ loaded: isLoaded }"
></div>
